var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('span',{staticStyle:{"margin-right":"10px"}},[_vm._v("ミニマリストの白T実験室 白T")]),_vm._v("produced by watnow")])}]

export { render, staticRenderFns }